
// 招聘信息
const recruitmentInformation = {
  titleOne: '无锡凯尔克人才宣言',
  contentOne: `
  <p>精密控制阀与工业流体技术的星辰大海中，人才是凯尔克锚定创新、问鼎全球的引擎。作为中加技术融合标杆企业，每台打破进口垄断的低温深冷阀、每套服务国家级能源工程的智能控流系统，都源自敢闯技术无人区的精英团队。在此，您书写的不仅是阀门参数，更是中国智造的工业史诗。<p>
  <ul style="margin-top: 20px;display:block;>
    <li style="">我们以"全球流体控制方案领航者"为愿景，为人才打造</li>
    <li style="">深度参与核电、LNG、超临界等特种阀门研发，用技术突破定义行业标准</li>
    <li style="">每月技术沙龙、年度"金扳手"工程师节、全员股权激励计划，让硬核科技与人文关怀共生共荣</li>
    <li style="">"双通道晋升体系"（技术专家/管理精英）+跨国技术交流计划，让工程师与全球顶尖实验室同频共振</li>
    <li style="">"技能认证补贴""专利成果分红""重大项目攻坚奖金"三阶激励，薪酬竞争力稳居长三角装备制造TOP10%</li>
  </ul>
  `,
  tableHead: [
    '职位名称',
    '工作地点',
    '需求人数',
    '工作经验',
    '学历要求',
    '具体要求',
    '操作',
  ],
  tableActionBtn: [
    '更多'
  ],
  dialog: {
    title: '职位描述',
    content: `
    岗位：仪表制造工艺技术员，负责仪表制造过程中的工艺技术。包括仪表零件的制造工艺方案，工艺实施以及仪表零件制造过程中需要的工艺装备的设计及制造实施等。<br />
    要求：有扎实的高级钳工的技术水平和能力，有对设计技术的理解能力以及对相关领域的领悟能力。工作认真负责，踏实敬业。
    `,
    btn: '我要申请'
  },
  list: [
    {
      title: '工作时光',
      content: '您想寻找一个能提供你不同发展潜力的企业吗？您想要提前构建您以后的发展之路和职业生涯吗？无锡凯尔克（KELK）是最合适您的地方，有素质和积极性的员工是我们企业成功的奠基石'
    },
    {
      title: '校园实习',
      content: '您的职业生涯可以比你想象中更早开始。在学校学习的同时，您有机会通过我们公司的实习机会，积累有价值的实践经验。这份经验能让您更容易得开展以后的工作，甚至有可能成为我们团队的一员。'
    }
  ]
}

// 校园实习
const campusInternship = {
  title: '实习生计划——与大国重器共成长',
  /* content: `
  <p>在实验室与车间之间，您是否期待一场真实的工业革命初体验？无锡凯尔克向在校生开放特种阀门研发实战赛道——在API 6D认证实验室参与低温深冷阀原型测试，在千万吨级LNG项目工单中学习智能控流系统设计，甚至与国家级能源工程攻坚组共探超临界阀门的材料极限。</p>
  <div>
    <ul style="margin-top: 20px;display:block;text-align:left;">
      <li style="font-weight:600;">
        <h3>您不是旁观者，而是未来“金扳手工程师”的种子：</h3>
      </li>
      <li>每名实习生匹配1名技术导师，独立承担子课题（如波纹管密封寿命优化、蝶阀流体仿真）；</li>
      <li>参与加拿大技术中心云端研讨会，优秀者直通“雏鹰计划”，毕业即享项目经理/研发工程师双通道晋升资格；</li>
      <li style="">您对碳中和的思考、对智能制造的洞察，正是下一代国产高端阀门迭代的灵感之源；</li>
      <li style="">以少年锋芒，破技术壁垒——KELK实习，是您职业生涯的第一份“行业标准”。</li>
    </ul>
  </div>
  `, */
  content: `
  <p>在实验室与车间之间，您是否期待一场真实的工业革命初体验？无锡凯尔克向在校生开放特种阀门研发实战赛道——在API 6D认证实验室参与低温深冷阀原型测试，在千万吨级LNG项目工单中学习智能控流系统设计，甚至与国家级能源工程攻坚组共探超临界阀门的材料极限。</p>
  <div>
    <ul style="margin-top: 20px;display:block;>
      <li style="">您不是旁观者，而是未来“金扳手工程师”的种子</li>
      <li>每名实习生匹配1名技术导师，独立承担子课题（如波纹管密封寿命优化、蝶阀流体仿真）</li>
      <li>参与加拿大技术中心云端研讨会，优秀者直通“雏鹰计划”，毕业即享项目经理/研发工程师双通道晋升资格</li>
      <li style="">您对碳中和的思考、对智能制造的洞察，正是下一代国产高端阀门迭代的灵感之源</li>
      <li style="">以少年锋芒，破技术壁垒——KELK实习，是您职业生涯的第一份“行业标准”</li>
    </ul>
  </div>
  `,
  titleOne: '可选择的部门',
  contentOne: '您想要测试您在大学期间所获得的理论知识是否能用于实际工作中吗？您可以通过自己的专业，选择合适自己的部门',
  listOne: [
    'IT',
    '财务',
    '行政',
    '生产管理',
    '销售',
    '采购',
    '人力资源',
    '生产-工艺过程',
    '市场',
    '商务拓展',
    '供应链管理',
  ],
  callMe: {
    title: '联系我们',
    contentOne: '公司名称：无锡凯尔克仪表阀门有限公司 联系地址：江苏省无锡市新区鸿山镇德育路6号 （214115）',
    contentTwo: '公司邮箱: info@kelkflow.com.cn 公司网址: www.kelkflow.com.cn',
    contentThree: '公司电话：+86-(0)510-85141699（杜经理） ',
  },
  group1: {
    title: '您需要提供',
    list: [
      '工程科学学位，工商管理学位或者相应资质',
      '工除去生产部门内部需要，您需要保证每周至少1-3次的实习时间',
      '工您选择部门的相关实践经验或者理论经验',
    ],
  },
  group2: {
    title: '我们将提供',
    list: [
      '参与实际事务的机会',
      '较好的锻炼个人工作独立性的机会',
      '和谐的工作环境',
    ],
  },
  footContent: `
  <p>加入我们这个充满活力的国际化团队吧！</p>
  <p>无锡凯尔克（KELK）是否有适合您的工作机会？您将在<span @click="toZhaopin">招聘信息</span>中得到最新的实习信息。</p>
  <p>将您的应聘资料发给我们，包括相关文件，标明您选择的工作部门。我们会逐一检查每份应聘资料，寻找是否有适合您的工作岗位。</p>
  `
}

// 工作时光
const workingHours = {
  title: '无锡凯尔克邀您共启未来',
  content: `
  您是否在寻找一个能激发潜能、链接全球工业前沿的舞台？无锡凯尔克——这家以“低温深冷阀打破进口垄断、超临界高压阀定义行业标准”的中加技术标杆企业，正为每一位追求卓越的工程师提供无限可能。<br />
  <p style="margin-top: 20px;display:block;">
    在这里，您将与“国家级能源项目攻坚团队”并肩，参与核电、LNG、氢能储运等特种阀门的研发<br />
    您将依托“双轨成长计划”（技术专家认证通道/跨国项目管理者孵化），在API 6D认证实验室与加拿大技术中心碰撞思维<br />
    您将见证自主设计的迷宫式调节阀如何为全球500强客户节省30%能耗。我们坚信：每一颗敢想敢为的种子，都值得被赋予破土的力量<br />
    加入KELK，以“金扳手工程师”之名，在智能制造的浪潮中，书写属于中国高端阀门技术的世界坐标
  </p>
  `,
  group: {
    title: '我们需要对未来有好奇心和积极性的工程师',
    content: '您想要测试您在大学期间所获得的理论知识是否能用于实际工作中吗？您可以通过自己的专业，选择合适自己的部门',
    list: [
      '基建&发展',
      '生产',
      '计划',
      '工业工程',
      '市场',
      '出口',
      '质量检查',
    ],
  },
  callMe: {
    title: '联系我们',
    contentOne: '公司名称：无锡凯尔克仪表阀门有限公司 联系地址：江苏省无锡市新区鸿山镇德育路6号 （214115）',
    contentTwo: '公司邮箱: info@kelkflow.com.cn 公司网址: www.kelkflow.com.cn',
    contentThree: '公司电话：+86-(0)510-85141699（杜经理）',
  },
  group1: {
    title: '您需要提供',
    list: [
      '工程科学学位，工商管理学位或者相应资质',
      '工除去生产部门内部需要，您需要保证每周至少1-3次的实习时间',
      '工您选择部门的相关实践经验或者理论经验',
    ],
  },
  group2: {
    title: '我们将提供',
    list: [
      '参与实际事务的机会',
      '较好的锻炼个人工作独立性的机会',
      '和谐的工作环境',
    ],
  },
  footContent: `
  <p>加入我们这个充满活力的国际化团队吧！</p>
  <p>无锡凯尔克（KELK）是否有适合您的工作机会？您将在<span @click="toZhaopin">招聘信息</span>中得到最新的实习信息。</p>
  <p>将您的应聘资料发给我们，包括相关文件，标明您选择的工作部门。我们会逐一检查每份应聘资料，寻找是否有适合您的工作岗位。</p>
  `
}

// 求职问题
const jobSearchProblem = {
  title: '如何应聘',
  content: '您可以通过以下方式参与应聘。如果您通过电子邮件申请，请通过Word或者PDF格式发送您的简历',
  callMe: {
    title: '联系我们',
    contentOne: '公司名称：无锡凯尔克仪表阀门有限公司 联系地址：江苏省无锡市新区鸿山镇德育路6号 （214115）',
    contentTwo: '公司邮箱: info@kelkflow.com.cn 公司网址: www.kelkflow.com.cn',
    contentThree: '公司电话：+86-(0)510-85141699（杜经理）',
  },
  zhaoPing: {
    title: '招聘职位',
    content: '招聘信息请点击'
  },
  group: [
    {
      id:1,
      title:'我可以主动向贵公司发送申请吗?',
      con:'是的，您可以主动发送申请。我们将会确定是否有合适您的岗位。我们会给您回音，但是也请您有耐心，因为我们需要更长的时间检查是否有一个特定的位置适合您。'
    },
    {
      id:2,
      title:'我的求职申请需要哪些信息和相关文件？',
      con:'您需要准备简历，相关文件，求职信（说明您的应聘原因）以及报告证书。请在您的应聘信息中注明：何时上岗，薪资要求以及需要我们注意的事项'
    },
    {
      id:3,
      title:'我应该何时发送求职申请?',
      con:'我们没有发送申请的最后期限。但若您是主动向我们申请，需在您能上岗前的2-3个月发送简历。如果空缺岗位招到合适的人员，您将不会再我们的的网站上找到相关的招聘信息。'
    },
    {
      id:4,
      title:'我的申请发送了以后会如何?',
      con:'当我们收到您的申请以后，会自动进入我们的数据库检查。如果您符合我们的岗位要求，我们将会联系您进行一个电话面试，询问一些初步简单的问题。如果没有其他问题，并且对您的简历也感兴趣，我们将邀请您参加第一轮面试。如果您通过了此次面试，我们还会安排第二轮面试。面试是否通过则要看您是否合适该岗位。'
    },
    {
      id:5,
      title:'我多久能得到回应?',
      con:'如果您是在线申请，您将会自动收到回执。发送电子邮件的将会收到邮件的临时答复。一般来说，我们需要四周的时间来处理您的申请。如有特殊情况发生，可能会更久一点。我们衷心希望您能明白这一点'
    },
    {
      id:6,
      title:'如何能保证我的信息安全?',
      con:'无锡凯尔克（KELK）接收到的数据都是按照数据保护法规定进行处理的。您的个人信息将会永远保密，并且只用于招聘。'
    },
    {
      id:7,
      title:'新员工培训如何进行?',
      con:'当您开始在无锡凯尔克（KELK）工作的时候，您将会对我们有一个大概的认识：认识您的新同事，我们的产品信息，使用范围以及无锡凯尔克（KELK）的组织架构，工作流程和服务流程。此外，作为职业培训，您也将参与我们的综合指导培训，让您对各个部门有个系统的了解。与此同时，部门有经验的员工也会向您提供帮助。'
    },
  ]
}



export default {
  title: '加盟凯尔克',
  tabs: [
    '招聘信息',
    '校园实习',
    '工作时光',
    '求职问题',
  ],
  // 招聘信息
  recruitmentInformation,
  // 校园实习
  campusInternship,
  // 工作时光
  workingHours,
  // 求职问题
  jobSearchProblem,
}


// WEBPACK FOOTER //
// ./src/config/lang/zh-CN/joinInPage.js